import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CreateLiveCleanroomDialog
  from 'components/CleanRooms/CrLiveCleanRoom/CreateLiveCleanroomDialog';
import LiveCrStatusChip from 'components/CleanRooms/CrLiveCleanRoom/LiveCrStatusChip';
import React, { memo, useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Box, Button, Tooltip, Typography,
} from '@mui/material';
import { CLEAN_ROOM_TYPES_MAP, CleanRoomTypes } from 'components/CleanRooms/constants';
import { LiveCrStatus } from 'components/CleanRooms/CrLiveCleanRoom/constant';


export const LiveQueryCell = memo(({ row }) => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [recreateDialogOpen, setRecreateDialogOpen] = useState(false);

  const { ID, liveCleanRoom, type } = row;

  const handleCreateOpen = () => setCreateDialogOpen(true);
  const handleCreateClose = () => setCreateDialogOpen(false);

  const handleRecreateOpen = () => setRecreateDialogOpen(true);
  const handleRecreateClose = () => setRecreateDialogOpen(false);

  if (type !== CleanRoomTypes.HYBRID_V2_CLEAN_ROOM) {
    return (
      <Tooltip title={`Live cleanroom not supported for cleanroom type: ${CLEAN_ROOM_TYPES_MAP[type]}`} placement='left'>
        <Typography variant='inherit' component='span'>
          N/A
        </Typography>
      </Tooltip>
    );
  }

  if (liveCleanRoom) {
    const isFailed = liveCleanRoom.status === LiveCrStatus.LIVE_CR_FAILED;

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LiveCrStatusChip
          status={liveCleanRoom.status}
          cleanRoomId={ID}
          liveCleanRoom={liveCleanRoom}
        />
        {isFailed && (
          <Tooltip title='Recreate live cleanroom session' arrow placement='right'>
            <Button
              variant='text'
              size='small'
              startIcon={<RefreshIcon />}
              onClick={handleRecreateOpen}
              sx={{
                minWidth: 'auto',
                padding: '4px 8px',
                fontSize: '0.75rem',
                color: '#9b2226',
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: 'rgba(239, 68, 68, 0.08)',
                },
              }}
            >
              Recreate
            </Button>
          </Tooltip>
        )}
        {isFailed && (
          <CreateLiveCleanroomDialog
            open={recreateDialogOpen}
            onClose={handleRecreateClose}
            cleanroom={row}
            isRecreate
            existingLcrId={liveCleanRoom.ID}
          />
        )}
      </Box>
    );
  }

  return (
    <>
      <Button
        variant='text'
        size='small'
        startIcon={<AccessTimeIcon />}
        sx={{ whiteSpace: 'nowrap' }}
        onClick={handleCreateOpen}
      >
        Create Live Cleanroom
      </Button>
      <CreateLiveCleanroomDialog
        open={createDialogOpen}
        onClose={handleCreateClose}
        cleanroom={row}
      />
    </>
  );
});

LiveQueryCell.displayName = 'LiveQueryCell';
